import React from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {searchActivities} from "../../actions/findActivities/search/get";

import activityIcon from '../../images/icons/active.svg';
import weightIcon from '../../images/icons/weight.svg';
import smokingIcon from '../../images/icons/smoking.svg';
import alcoholIcon from '../../images/icons/drinking.svg';

class Checkbox extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            selectedCheckboxes: [],
        };

        this.update = this.update.bind(this);
    }

    update(e) {
        let selected = this.state.selectedCheckboxes;

        let index;

        if (e.target.checked) {
            selected.push(e.target.value);
            if (e.target.value === 'unknown') {
            selected = ['unknown'];
            } else {
            const unknownIndex = selected.indexOf('unknown');
            if (unknownIndex > -1) {
                selected.splice(unknownIndex, 1);
            }
            }
        } else {
            index = selected.indexOf(e.target.value);
            selected.splice(index, 1);
        }

        this.setState({ selectedCheckboxes: selected.slice() });
        this.props.onChange(e);
        this.props.searchActivities(this.props.searchValues, this.props.selectedFilters);
    }

    render() {
        const { options, editable, classes, name, selectedFilters, filter_group_id, pathwayImage } = this.props;

        let icons = [];
        if (pathwayImage) {
            icons = {activityIcon, weightIcon, smokingIcon, alcoholIcon};
        }

        return (
            <div className="input-checkbox-group">
            {options.length === 0 ? <option value="">Loading...</option> : null}
            {options.map(opt => (
                <div className={['input-checkbox', pathwayImage && 'with-icon', classes && classes].join(' ')} key={opt.id + name}>
                    {pathwayImage && <img src={icons[`${opt.value}Icon`]} alt={`${opt.value} image icon`} /> }
                    <input
                        type="checkbox"
                        id={name + (editable ? (typeof opt.id === "undefined" ? opt.value : opt.id) : opt.key)}
                        value={editable ? (typeof opt.id === "undefined" ? opt.value: opt.id) : opt.key}
                        onChange={this.update}
                        name={name}
                        checked={selectedFilters[filter_group_id] && selectedFilters[filter_group_id].indexOf(typeof opt.id === "undefined" ? opt.value : opt.id.toString()) > -1}
                        key={name + opt.id}
                    />
                    <label key={opt.id + name + opt.id} htmlFor={name + (editable ? (typeof opt.id === "undefined" ? opt.value: opt.id) : opt.key)}>{filter_group_id === 4 ? opt.displayText : opt.value}</label>
                </div>
            ))}
            </div>
        );
    }
  }

Checkbox.propTypes = {
    name: PropTypes.string,
    classes: PropTypes.string,
    editable: PropTypes.number.isRequired,
};

Checkbox.defaultProps = {
    name: '',
    classes: '',
    editable: 1,
};

const mapStateToProps = (state) => ({
    selectedFilters : state.selectedFilters,
    searchValues: state.searchValues,
});
const mapDispatchToProps = dispatch => ({
    searchActivities: (values, filters) => {
        dispatch(searchActivities(values, filters));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Checkbox);


